export const DEFAULT_HOLD_REASONS = [
    "Reorder Form",
    "Temperature",
    "Pediatric Blast",
    "Oral Health Blast",
    "Baby Drops"
]
